import { useContext, useEffect, useState } from "react";
import PostAuthor from "../components/PostAuthor";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  BASE_URL,
  UserContext,
} from "../contexts/UserContext";
import axios from "axios";
import Loader from "../components/Loader/Loader";
import ButtonLoader from "../components/ButtonLoader";
import { followUnFollowUser } from "../utels";

const PostDetail = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeletedLoading] = useState(false);
  const [isFollow, setIsFollow] = useState(false);
  const [user, setUser] = useState(null);

  const { postId } = useParams();
  const { currentUser, setError, setMessage } = useContext(UserContext);
  const navigate = useNavigate();
  console.log(user);
  // Fetch Post
  useEffect(() => {
    const getPostDetails = async () => {
      try {
        const { data } = await axios.get(
          `${BASE_URL}/posts/post/details/${postId}`
        );
        setPost(data.post);
        
      } catch (error) {
        setError(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    };

    getPostDetails();
  }, [postId]);

  // Fetch Author
  useEffect(() => {
    if (!post?.postedBy) return;

    const getUserProfile = async () => {
      try {
        const { data } = await axios.get(
          `${BASE_URL}/users/user-details/${post.postedBy}`
        );

        setUser(data.user);
        setIsFollow(
          data.user.followers?.includes(currentUser?._id)
        );
      } catch (error) {
      }
    };

    getUserProfile();
  }, [post?.postedBy]);

  const handleDeletepost = async () => {
    if (!window.confirm("Delete this post?")) return;

    try {
      setDeletedLoading(true);
      const { data } = await axios.delete(
        `${BASE_URL}/posts/delete/post/${postId}`,
        { withCredentials: true }
      );
      setMessage(data.message);
      navigate("/");
    } catch (error) {
      setError(error?.response?.data?.message);
    } finally {
      setDeletedLoading(false);
    }
  };

const handleFollow = async () => {
  try {
    const data = await followUnFollowUser(post?.postedBy);

    setUser(data?.user);

    const isUserFollowed =
      data?.user?.followers?.some(
        (f) => f?.toString() === currentUser?._id?.toString()
      ) || false;

    setIsFollow(isUserFollowed);

    setMessage(data?.message);
  } catch (error) {
    console.log(error);
  }
};

  const calculateReadingTime = (text) => {
    const words = text?.split(" ").length;
    return Math.ceil(words / 200);
  };

  if (loading) return <Loader />;
  if (!post) return <h2>Post not found</h2>;

  return (
    <section className="blog-detail">
      <div className="blog-container">

        {/* Title */}
        <h1 className="blog-title">{post.title}</h1>

        {/* Meta Info */}
        <div className="blog-meta">
          <PostAuthor userId={post?.postedBy} />

          <div className="meta-right">
            <span>
              {new Date(post.createdAt).toDateString()} ·{" "}
              {calculateReadingTime(post.description)} min read
            </span>

            {currentUser?._id !== post?.postedBy && (
              <button
                className={`follow-btn ${isFollow ? "following" : ""}`}
                onClick={handleFollow}
              >
                {isFollow ? "Following" : "Follow"}
              </button>
            )}

            {currentUser?._id === post?.postedBy && (
              <div className="author-buttons">
                <Link to={`/post/${post._id}/edit`} className="edit-btn">
                  Edit
                </Link>
                <button onClick={handleDeletepost} className="delete-btn">
                  {deleteLoading ? <ButtonLoader /> : "Delete"}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Hero Image */}
        {post?.postImg && (
         <div className="blog-image">
  <img
    src={post.postImg.secure_url}
    alt={post.title}
    style={{
      width: "100%",
      height: "300px",
      objectFit: "cover",
      borderRadius: "10px"
    }}
  />
</div>
        )}

        {/* Blog Content */}
        <div
          className="blog-content"
          dangerouslySetInnerHTML={{ __html: post.description }}
        />

      </div>
    </section>
  );
};

export default PostDetail;
